/**
 * Icon Color
 */
export var ViewColor;
(function (ViewColor) {
    ViewColor["SUCCESS"] = "SUCCESS";
    ViewColor["ERROR"] = "ERROR";
    ViewColor["INFO"] = "INFO";
    ViewColor["WARNING"] = "WARNING";
    ViewColor["TERTIARY"] = "TERTIARY";
    ViewColor["WHITE"] = "WHITE";
})(ViewColor || (ViewColor = {}));
export var JustifyContent;
(function (JustifyContent) {
    JustifyContent["SPACE_BETWEEN"] = "space-between";
    JustifyContent["SPACE_AROUND"] = "space-around";
    JustifyContent["FLEX_START"] = "flex-start";
    JustifyContent["FLEX_END"] = "flex-end";
    JustifyContent["CENTER"] = "center";
})(JustifyContent || (JustifyContent = {}));
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiVmlld0VudW0uanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi9jb21wb25lbnRzL3ZpZXcvVmlld0VudW0udHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUE7O0dBRUc7QUFDSCxNQUFNLENBQU4sSUFBWSxTQU9YO0FBUEQsV0FBWSxTQUFTO0lBQ25CLGdDQUFtQixDQUFBO0lBQ25CLDRCQUFlLENBQUE7SUFDZiwwQkFBYSxDQUFBO0lBQ2IsZ0NBQW1CLENBQUE7SUFDbkIsa0NBQXFCLENBQUE7SUFDckIsNEJBQWUsQ0FBQTtBQUNqQixDQUFDLEVBUFcsU0FBUyxLQUFULFNBQVMsUUFPcEI7QUFPRCxNQUFNLENBQU4sSUFBWSxjQU1YO0FBTkQsV0FBWSxjQUFjO0lBQ3hCLGlEQUErQixDQUFBO0lBQy9CLCtDQUE2QixDQUFBO0lBQzdCLDJDQUF5QixDQUFBO0lBQ3pCLHVDQUFxQixDQUFBO0lBQ3JCLG1DQUFpQixDQUFBO0FBQ25CLENBQUMsRUFOVyxjQUFjLEtBQWQsY0FBYyxRQU16QiJ9